import { gql } from 'graphql-request';

import {
  UserCreatedAt,
  UserFullName,
  UserID,
  UserImageFile,
  UserImageUUID,
  UserLocale,
  UserNanoID,
  UserPermissionsAction,
  UserUUID,
  UserClient,
  UserCurrentTeamID,
  UserCurrentTeamUUID,
  UserCurrentTeamNanoID,
  UserRoleName,
  UserBlocked,
  UserCurrentTeamUseLdApiAt,
  UserNeedAcceptDocuments
} from '../../main/users/usersTypes';
import { AcceptanceDocumentID } from '../../main/acceptanceDocuments/acceptanceDocumentsTypes';

export interface FetchCurrentUserQueryResponse {
  id: UserID;
  uuid: UserUUID;
  nanoId: UserNanoID;
  fullName: UserFullName;
  locale: UserLocale;
  createdAt: UserCreatedAt;
  client: UserClient;
  blocked: UserBlocked;
  needAcceptDocuments: UserNeedAcceptDocuments;
  documentsToAccept: {
    id: AcceptanceDocumentID;
  }[];
  image: {
    uuid: UserImageUUID;
    file: UserImageFile;
  };
  currentTeam: {
    id: UserCurrentTeamID;
    uuid: UserCurrentTeamUUID;
    nanoId: UserCurrentTeamNanoID;
    useLdApiAt: UserCurrentTeamUseLdApiAt;
  };
  frontendActions: { [action: UserPermissionsAction]: true };
  roles: {
    name: UserRoleName;
  }[];
}

export const FETCH_CURRENT_USER = gql`
  query FetchCurrentUser {
    currentUser {
      id
      uuid
      nanoId
      fullName
      locale
      createdAt
      client
      blocked
      needAcceptDocuments
      documentsToAccept {
        id
      }
      image {
        uuid
        file
      }
      currentTeam {
        id
        uuid
        nanoId
        useLdApiAt
      }
      frontendActions
      roles {
        name
      }
    }
  }
`;
